import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { api } from '@/lib/api';
import { FileField, TextField, Select } from '@/components/admin/shared';
import RichTextEditor from '@/components/admin/RichTextEditor';

export default function MeetGManager() {
  const [state, setState] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => { api.get('/meet-g').then(({ data }) => setState(data)).catch(() => setState({})); }, []);

  if (!state) return <div className="pg-card p-10 text-center text-[var(--pg-ink-muted)]">Loading…</div>;

  const upd = (k) => (v) => setState((s) => ({ ...s, [k]: v }));

  const save = async () => {
    setSaving(true); setMsg(null);
    try {
      const { data } = await api.put('/admin/meet-g', state);
      setState(data); setMsg('Saved.');
    } catch (e) { setMsg(e?.response?.data?.detail || 'Save failed'); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-6" data-testid="admin-meet-g-manager">
      <div className="pg-card p-6">
        <p className="pg-label">HERO MEDIA</p>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
          <Select label="Hero kind" value={state.hero_kind || 'image'} onChange={upd('hero_kind')} options={[
            { value: 'image', label: 'Image' },
            { value: 'video', label: 'Video' },
          ]} />
          <div className="md:col-span-2">
            <FileField label={`Hero ${state.hero_kind || 'image'}`} kind={state.hero_kind === 'video' ? 'audio' : 'image'} value={state.hero_url || ''} onChange={upd('hero_url')} accept={state.hero_kind === 'video' ? 'video/*' : 'image/*'} />
          </div>
        </div>
      </div>

      <div className="pg-card p-6 space-y-6">
        <p className="pg-label">PAGE CONTENT</p>
        <div>
          <label className="text-xs font-mono tracking-widest text-[var(--pg-ink-muted)]">Biography</label>
          <div className="mt-2">
            <RichTextEditor value={state.biography || ''} onChange={upd('biography')} placeholder="Tell your story…" minHeight={200} testId="meet-g-biography-editor" />
          </div>
        </div>
        <div>
          <label className="text-xs font-mono tracking-widest text-[var(--pg-ink-muted)]">Mission</label>
          <div className="mt-2">
            <RichTextEditor value={state.mission || ''} onChange={upd('mission')} placeholder="What is the mission?" minHeight={160} testId="meet-g-mission-editor" />
          </div>
        </div>
        <div>
          <label className="text-xs font-mono tracking-widest text-[var(--pg-ink-muted)]">Current focus</label>
          <div className="mt-2">
            <RichTextEditor value={state.current_focus || ''} onChange={upd('current_focus')} placeholder="What are you focused on right now?" minHeight={160} testId="meet-g-focus-editor" />
          </div>
        </div>
      </div>

      <button onClick={save} disabled={saving} className="pg-btn-primary w-full justify-center !py-3 disabled:opacity-60 inline-flex items-center gap-2" data-testid="meet-g-save">
        <Save size={14} /> {saving ? 'SAVING…' : 'PUBLISH MEET G'}
      </button>
      {msg && <p className="text-xs font-mono text-[var(--pg-tertiary)] text-center">{msg}</p>}
    </div>
  );
}
